
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAddCus } from '@/api/customer';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';

const statusOptions = [
  {
    value: '1',
    label: '添加成功'
  },
  {
    value: '2',
    label: '未添加成功'
  }
];

@Component({
  name: 'CustomerAdded'
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 1,
    total: 0
  };

  private page = 1;
  private size = 10;

  private listLoading = false;

  private formSearch = {
    customer: '',
    status: ''
  };
  private statusOptions = statusOptions;
  private tableData = [];

  created() {
    this.getAddCus();
  }
  handleCurrentChange(size: number) {
    this.page = size;
    this.getAddCus();
  }

  handlePageSizeChange(size: number) {
    this.size = size;
    this.getAddCus();
  }
  // 搜索
  private handleSearch() {
    this.getAddCus();
  }

  // 清空
  private handleSearchClear() {
    this.formSearch = {
      customer: '',
      status: ''
    };
    this.getAddCus();
  }

  // 获取列表
  private getAddCus() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      name: this.formSearch.customer,
      customer_state: this.formSearch.status,
      page: this.page,
      size: this.size
    };
    getAddCus(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listLoading = false;
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.tableData = [];
        let msg = err.msg;
      });
  }
}
